import { BrowserModule } from '@angular/platform-browser';
// Modules
import { ConfigModule } from 'NewAngular/config/config.module';
import * as i0 from "@angular/core";
export class ModuleUpsellModule {
}
ModuleUpsellModule.ɵfac = function ModuleUpsellModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ModuleUpsellModule)(); };
ModuleUpsellModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ModuleUpsellModule });
ModuleUpsellModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule, ConfigModule] });
